import type { Order } from './order';

export const ENDPOINT = 'api/app/orders';

export interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
}

export interface ListOrdersRequest {
  page?: number;
  per_page?: number;
}

export interface ListOrdersResponse {
  current_page: number;
  data: Order[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: PaginationLink[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}
